import { Action } from '@ngrx/store';
import { Site } from '../site/site.model';

export enum SiteWsActionTypes {
  LocalCreateSiteSuccessWs = '[Site WS] Local Create Sites Success',
  LocalCreateSiteFailureWs = '[Site WS] Local Create Sites Failure',
  LocalUpdateSiteSuccessWs = '[Site WS] Local Update Sites Success',
  LocalUpdateSiteFailureWs = '[Site WS] Local Update Sites Failure',
  LocalRemoveSiteSuccessWs = '[Site WS] Local Remove Sites Success',
  LocalRemoveSiteFailureWs = '[Site WS] Local Remove Sites Failure',
  GlobalCreateSiteSuccessWs = '[Site WS] Global Create Sites Success',
  GlobalUpdateSiteSuccessWs = '[Site WS] Global Update Sites Success',
  GlobalRemoveSiteSuccessWs = '[Site WS] Global Remove Sites Success',
}

export class LocalCreateSiteSuccessWs implements Action {
  readonly type = SiteWsActionTypes.LocalCreateSiteSuccessWs;

  constructor(public payload: { id: string; correlation_id: string }) {}
}

export class LocalCreateSiteFailureWs implements Action {
  readonly type = SiteWsActionTypes.LocalCreateSiteFailureWs;

  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class LocalUpdateSiteSuccessWs implements Action {
  readonly type = SiteWsActionTypes.LocalUpdateSiteSuccessWs;

  constructor(public payload: { id: string; correlation_id: string }) {}
}

export class LocalUpdateSiteFailureWs implements Action {
  readonly type = SiteWsActionTypes.LocalUpdateSiteFailureWs;

  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class LocalRemoveSiteSuccessWs implements Action {
  readonly type = SiteWsActionTypes.LocalRemoveSiteSuccessWs;

  constructor(public payload: { correlation_id: string }) {}
}

export class LocalRemoveSiteFailureWs implements Action {
  readonly type = SiteWsActionTypes.LocalRemoveSiteFailureWs;

  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class GlobalCreateSiteSuccessWs implements Action {
  readonly type = SiteWsActionTypes.GlobalCreateSiteSuccessWs;
}

export class GlobalUpdateSiteSuccessWs implements Action {
  readonly type = SiteWsActionTypes.GlobalUpdateSiteSuccessWs;

  constructor(public payload: { site: Site }) {}
}

export class GlobalRemoveSiteSuccessWs implements Action {
  readonly type = SiteWsActionTypes.GlobalRemoveSiteSuccessWs;

  constructor(public payload: { id: Site['id'] }) {}
}

export type SiteWsActions =
  | LocalCreateSiteSuccessWs
  | LocalCreateSiteFailureWs
  | LocalUpdateSiteSuccessWs
  | LocalUpdateSiteFailureWs
  | LocalRemoveSiteSuccessWs
  | LocalRemoveSiteFailureWs
  | GlobalCreateSiteSuccessWs
  | GlobalUpdateSiteSuccessWs
  | GlobalRemoveSiteSuccessWs;
